<template>
  <slot v-bind="{openRetailerDrawer, closeRetailerDrawer, isRetailerDrawerOpen}"></slot>
  <retailer-drawer
    :key="selectedRetailer"
    :is-drawer-open="isRetailerDrawerOpen"
    :is-account-section="isAccountSection"
    @close="closeRetailerDrawer"
  />
</template>
<script>
import {PdlDialog} from '@pedal/pdl-dialog';
import RetailerDrawer from '../../drawer/retailer/RetailerDrawer.vue';
import {mapState, mapActions} from 'vuex';

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    PdlDialog,
    RetailerDrawer,
  },
  props: {
    isAccountSection: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isRetailerDrawerOpen: false,
    };
  },
  computed: {
    ...mapState('user', ['selectedRetailer']),
    ...mapActions('user', ['fetchUserPreferredRetailer']),
  },
  async mounted() {
    await this.fetchUserPreferredRetailer;
  },
  methods: {
    openRetailerDrawer() {
      this.isRetailerDrawerOpen = true;
    },
    closeRetailerDrawer() {
      this.isRetailerDrawerOpen = false;
    },
  },
};
</script>
